/**
 * Pending Approval Page — shown after signup when manual approval is required
 */

import { Link } from 'react-router-dom';

export function PendingApprovalPage() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="20" fill="#1e293b" stroke="#334155" strokeWidth="2" />
            <path d="M24 14v12l8 4" stroke="#4F7CFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 style={styles.title}>Account Pending Approval</h1>
        <p style={styles.message}>
          Your account has been created and is awaiting approval from an administrator.
          You'll be able to sign in once your account is approved.
        </p>
        <Link to="/login" style={styles.button}>Back to Sign In</Link>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0d0d0d 0%, #1a1a1a 100%)',
  },
  card: {
    background: '#1a1a1a',
    borderRadius: 12,
    padding: '48px 36px',
    width: 420,
    maxWidth: '90vw',
    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.4)',
    border: '1px solid #333333',
    textAlign: 'center' as const,
  },
  iconWrap: {
    marginBottom: 20,
  },
  title: {
    color: '#f1f5f9',
    fontSize: 22,
    fontWeight: 600,
    margin: '0 0 12px',
  },
  message: {
    color: '#94a3b8',
    fontSize: 14,
    lineHeight: 1.6,
    margin: '0 0 28px',
  },
  button: {
    display: 'inline-block',
    background: '#4F7CFF',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '10px 24px',
    fontSize: 14,
    fontWeight: 600,
    textDecoration: 'none',
    cursor: 'pointer',
  },
};
